export default "__VITE_ASSET__CjatYSPu__"